var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", width: "100%", height: "100%" } },
    [
      _c(
        "div",
        {
          staticClass: "containerVideoDiv",
          on: {
            click: function($event) {
              return _vm.sendVideo("ver")
            }
          }
        },
        [
          this.params.data.url != null
            ? _c(
                "i",
                {
                  staticClass: "BtnIconSee material-icons",
                  staticStyle: { color: "#27488e" }
                },
                [_vm._v("videocam_outlined")]
              )
            : _c("i", { staticClass: "material-icons" }, [
                _vm._v("videocam_off_outlined")
              ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "containerVideoDiv",
          on: {
            click: function($event) {
              return _vm.sendVideo("descargar")
            }
          }
        },
        [
          this.params.data.url != null
            ? _c(
                "i",
                {
                  staticClass: "BtnIconDownload material-icons",
                  staticStyle: { color: "#27488e" }
                },
                [_vm._v("file_download_outlined")]
              )
            : _c("i", { staticClass: "material-icons" }, [
                _vm._v("file_download_off_outlined")
              ])
        ]
      ),
      _c("br")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }